<ul>
  <li tabindex="0" *ngFor="let tab of tabs" (keydown.space)="onKey(tab)" (keydown.enter)="onKey(tab)" [ngClass]="{'active': tab.route === activeTab}">
    <a bw-anchor-legacy [routerLink]="tab.route" (click)="onClick(tab)" >{{tab.label}}</a>
  </li>
</ul>